<div class="progress" style="height: 20px; border-radius: 0%;">
    <div class="progress-bar progress-color" role="progressbar" [ngStyle]="progresStyle()"  aria-valuenow="25" aria-valuemin="0"
    aria-valuemax="100"></div>
</div>
